import StageStatusIcon from "./StageStatusIcon";

const StageButton = ({
  stage,
  status,
  isActive,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      className={`border border-dBlue-100 rounded-full px-4 py-2 text-left max-lg:text-sm ${
        isActive ? "bg-dBlue-100 shadow-100" : ""
      }`}
    >
      <div className="flex items-center gap-2">
        <StageStatusIcon status={status} />

        <div>
          <p className="font-figtreeMedium">
            Stage : {stage.id}
          </p>

          <p className="max-lg:text-xs">
            {stage.name}
          </p>
        </div>
      </div>
    </button>
  );
};

export default StageButton;